import { render, staticRenderFns } from "./default_no_sidebar.vue?vue&type=template&id=56414ebf&scoped=true&lang=pug&"
import script from "./default_no_sidebar.vue?vue&type=script&lang=js&"
export * from "./default_no_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./default_no_sidebar.vue?vue&type=style&index=0&id=56414ebf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56414ebf",
  null
  
)

export default component.exports